import { render, staticRenderFns } from "./ZBParser.vue?vue&type=template&id=b09116f6&scoped=true"
import script from "./ZBParser.vue?vue&type=script&lang=js"
export * from "./ZBParser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09116f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城商家端\\fhj-web-dyh-mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b09116f6')) {
      api.createRecord('b09116f6', component.options)
    } else {
      api.reload('b09116f6', component.options)
    }
    module.hot.accept("./ZBParser.vue?vue&type=template&id=b09116f6&scoped=true", function () {
      api.rerender('b09116f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/ZBParser.vue"
export default component.exports